import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';
import { UserConditionModel } from '../models/user/userConditionModel';
import { UserConditionListFilterModel } from '../models/user/userConditionListFilterModel';
import { UserPersonalConditionModel } from '../models/user/userPersonalConditionModel';
import { UserConditionType } from '../common/enums';
import { UserConditionTypeModel } from '../models/user/userConditionTypeModel';
import { UserConditionTypeFilterModel } from '../models/user/userConditionTypeFilterModel';

class UserConditionService {

    authService = new AuthService();

    constructor() {
        //axios.defaults.baseURL = `${Constants.apiUrl}`;
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    }

    getAllUserConditions(from: number, numberOfRows: number, filters: UserConditionListFilterModel) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/getAll/${from}/${numberOfRows}/`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(filters)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getCondition(conditionId: number, from: number, numberOfRows: number, filters: UserConditionTypeFilterModel) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/get/${conditionId}/${from}/${numberOfRows}`,
            method: 'post',
            data: JSON.stringify(filters)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getPersonalConditions() {
        return axios({
            url: `${Constants.apiUrl}/userCondition/personalConditions/`,
            method: 'get'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addUserCondition(condition: UserConditionModel) {
        return axios({
            url: `${Constants.apiUrl}/userCondition`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(condition)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    updateUserCondition(conditionId: number, conditionTypes: Array<UserConditionTypeModel>) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/${conditionId}`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(conditionTypes)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteCondition(conditionId: number) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/${conditionId}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteConditionType(conditionTypeId: number) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/deleteType/${conditionTypeId}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    createPersonalCondition(personalCondition: UserPersonalConditionModel) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/createPersonal/`,
            method: 'post',
            data: JSON.stringify(personalCondition)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deletePersonalCondition(conditionId: number) {
        return axios({
            url: `${Constants.apiUrl}/userCondition/deletePersonal/${conditionId}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default UserConditionService;